import Header from "../components/Header"
import ScanWallet from "../components/ScanWallet";
const ScanPage = () => {
    return(
        <div>
            <Header /> 
            <ScanWallet />
        </div>
    )
}

export default ScanPage;